import { render, staticRenderFns } from "./ModuleUpdater.vue?vue&type=template&id=5403abd8&"
import script from "./ModuleUpdater.vue?vue&type=script&lang=js&"
export * from "./ModuleUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports